import Axios from "axios";
import React, { useState } from "react";

const SoloCompiElement = ({ participant, competition, onlineSubmission }) => {
  const [semisDisabled, setSemisDisabled] = useState(false);
  const [finalsDisabled, setFinalsDisabled] = useState(false);

  const [inSemis, setInSemis] = useState(participant.inSemis);
  const [inFinals, setInFinals] = useState(participant.inFinals);

  function padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  function formatDate(date) {
    return [
      padTo2Digits(date.getDate()),
      padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
    ].join("/");
  }

  const onSemisClick = () => {
    setSemisDisabled(true);
    if (inSemis) {
      Axios.post(
        "https://ashish.moodi.org/competitions/removeSemis",
        {
          participant: participant.crId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            setInSemis(false);
            setSemisDisabled(false);
          }
        })
        .catch((err) => console.error(err));
    } else {
      Axios.post(
        "https://jarvis.moodi.org/competitions/intoSemis",
        {
          participant: participant.crId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            setInSemis(true);
            setSemisDisabled(false);
          }
        })
        .catch((err) => console.error(err));
    }
  };

  const onFinalsClick = () => {
    setFinalsDisabled(true);
    if (inFinals) {
      Axios.post(
        "https://jarvis.moodi.org/competitions/removeFinals",
        {
          participant: participant.crId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            setInFinals(false);
            setFinalsDisabled(false);
          }
        })
        .catch((err) => console.error(err));
    } else {
      Axios.post(
        "https://jarvis.moodi.org/competitions/intoFinals",
        {
          participant: participant.crId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => {
          if (res.data.status === "done") {
            setInFinals(true);
            setFinalsDisabled(false);
          }
        })
        .catch((err) => console.error(err));
    }
  };

  return (
    <tr key={participant.phone} className="border border-primary">
      {competition.isSlottingDone ? <td>{participant.slotNumber}</td> : <></>}
      <td>{participant.userName}</td>
      <td>{participant.MI_NO}</td>
      <td>{participant.phone}</td>
      <td>{participant.email}</td>
      {competition.isOnline ? (
        <>
          {semisDisabled ? (
            <td>
              <div className="d-flex justify-content-center align-items-center">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </td>
          ) : (
            <td>
              <div className="d-flex justify-content-center align-items-center">
                <input
                  class=""
                  type="checkbox"
                  id="inlineCheckbox1"
                  disabled={semisDisabled}
                  checked={inSemis}
                  onClick={onSemisClick}
                />
              </div>
            </td>
          )}
          {finalsDisabled ? (
            <td>
              <div className="d-flex justify-content-center align-items-center">
                <div class="spinner-border spinner-border-sm" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            </td>
          ) : (
            <td>
              <div className="d-flex justify-content-center align-items-center">
                <input
                  class=""
                  type="checkbox"
                  id="inlineCheckbox2"
                  value={inFinals}
                  disabled={finalsDisabled}
                  onClick={onFinalsClick}
                />
              </div>
            </td>
          )}
        </>
      ) : (
        <></>
      )}
      <td>{participant.collegeName}</td>
      <td>{participant.cityName}</td>
      {competition.isOnline ? (
        <>
          <td>
            <a
              href={
                onlineSubmission.find(
                  (element) => element.userTeamId === participant.userId
                )
                  ? onlineSubmission.find(
                      (element) => element.userTeamId === participant.userId
                    ).submissionLink
                  : ""
              }
            >
              {onlineSubmission.find(
                (element) => element.userTeamId === participant.userId
              )
                ? onlineSubmission.find(
                    (element) => element.userTeamId === participant.userId
                  ).submissionLink
                : ""}
            </a>
          </td>
          <td>
            {onlineSubmission.find(
              (element) => element.userTeamId === participant.userId
            )
              ? formatDate(
                  new Date(
                    onlineSubmission.find(
                      (element) => element.userTeamId === participant.userId
                    ).submittedOn
                  )
                )
              : ""}
          </td>
        </>
      ) : (
        <></>
      )}
    </tr>
  );
};

export default SoloCompiElement;
